<template>
  <div class="pdf-item" :componentvalue="formattedValue">
    <el-form-item :label="currentField.label" :label-width="currentField.labelWidth + 'px'">
      <el-date-picker
        v-model="currentField.componentValue"
        type="datetime"
        placeholder="Select date and time"
        v-on:change="dateTimePickerChange"
      ></el-date-picker>
    </el-form-item>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: 'DatetimePicker',
  props: ['currentField'],
  data() {
    return {
      // date: ''
    };
  },
  methods: {
    dateTimePickerChange(value) {
      this.currentField.componentValue = value;
    }
  },
  computed: {
    formattedValue() {
      const val = this.currentField.componentValue;
      if (!val) return '';
      const df = this.$store.state.settings.dateFormat || 'DD-MM-YYYY';
      const tf = this.$store.state.settings.timeFormat === 24 ? 'HH:mm' : 'h:mm A';
      return moment(val).format(`${df} ${tf}`);
    }
  }
};
</script>
